import { GenericModelController } from "@/controllers/model-controllers/abstract/generic-model-controller"
import { RentalIntakeItem } from "@/models/rental-intake-item.model"
import type { IRentalIntakeItem } from "@/interfaces/api/rental-intake-item.interface"
import { RentalIntakeItemRepository } from "@/repositories/rental-intake-item-repository"
import { useRentalIntakeItemStore } from "@/store/rental-intake-item.store"
import { storeToRefs } from "pinia"
import { useSocketSynchronizationHandlers } from "@/composables/socket/socket-synchronization-handlers"

export class RentalIntakeItemController extends GenericModelController<
  RentalIntakeItem,
  IRentalIntakeItem,
  RentalIntakeItemRepository
> {
  constructor() {
    const rentalIntakeItemStore = useRentalIntakeItemStore()
    const { rentalIntakeItems } = storeToRefs(rentalIntakeItemStore)

    const storeFunctionsConfig = {
      collection: rentalIntakeItems
    }

    super(RentalIntakeItem, storeFunctionsConfig, new RentalIntakeItemRepository())

    this.socketSynchronizationHandlers = useSocketSynchronizationHandlers(
      RentalIntakeItem,
      rentalIntakeItems
    )
  }
}
